import React, { useState, useEffect } from 'react';
import { dataApi } from "../../apis/dataApi";
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';
import '../../css/fonts.css'
import '../../css/style.css'
import '../../css/bootstrap@5.3.0.min.css'
import bg from '../../assets/Walpapers/Wallpaper.png';
import kidzos from '../../assets/Iconos/kidzos.png';
import card from '../../assets/Iconos/card.png';
import { useTranslation } from 'react-i18next';
import LogoCam from '../../assets/Logotipo/Logo_cetesninos_color.png';
import { useNavigate } from 'react-router-dom';


function Meta() {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const [isLoading, setIsLoading] = useState(false);

    // State for query params
    const [code, setCode] = useState("");
    const [amount, setAmount] = useState("");
    const [backAccountID, setBackAccountID] = useState("");
    const [tParam, setTParam] = useState("");
    const [bParam, setBParam] = useState("");

    useEffect(() => {
        setCode(searchParams.get("code") || "");
        setAmount(searchParams.get("amount") || "");
        setBackAccountID(searchParams.get("backAccountID") || "");
        setTParam(searchParams.get("t") || "");
        setBParam(searchParams.get("b") || "");
    }, [location.search]);

    // Carousel state for products
    const [products, setProducts] = useState([]); // { name, value, image (base64) }
    const [activeIndex, setActiveIndex] = useState(0);

    // Load products from backend (shared for all users)
    useEffect(() => {
        async function fetchProducts() {
            const prods = await dataApi.getProducts();
            setProducts(prods);
        }
        fetchProducts();
    }, []);

    const handlePrev = () => {
        setActiveIndex((prev) => (prev === 0 ? products.length - 1 : prev - 1));
    };
    const handleNext = () => {
        setActiveIndex((prev) => (prev === products.length - 1 ? 0 : prev + 1));
    };

    const handleClickResumen = (e) => {
        e.preventDefault();
        setIsLoading(true);
        // Get selected carousel item
        const selectedItem = activeIndex;
        let productInfo = '';
        if (products.length > 0) {
            const prod = products[selectedItem];
            // Encode as name|value (or JSON if you prefer)
            productInfo = encodeURIComponent(`${prod.name}|${prod.value}`);
        }
        // Build query string
        const query = `?code=${code}&amount=${amount}&backAccountID=${backAccountID}&t=${tParam}&b=${bParam}&selectedItem=${selectedItem}&productInfo=${productInfo}`;
        navigate(`/resumen${query}`);
        setTimeout(() => {
            setIsLoading(false);
        }, 2000);
    };
    return (
        <div className="cetes-background" style={{ backgroundImage: `url(${bg})` }}>
            <div className="cetes-background-inner">
                <div className="cetes-junior-header">
                    <div className="info-header-cetes-junior">
                        <div className="text-header-cetes">
                            <h4 className="text-header-mayus">{t('meta_title')}<b>{t('meta_title_bold')}</b></h4>
                            <h4>{t('meta_subtitle')}</h4>
                        </div>
                    </div>
                    <div className="logo_CETES_junior">
                        <div className="logo logo-cetes">
                            <img src={LogoCam} alt="Logo organización KidZania" />
                        </div>
                    </div>
                </div>
                <div className="registro-content">
                    <div className="registro-form-cetes">
                        <div className="registro-form-cetes-inner" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative', height: '300px' }}>
                            <button
                                onClick={handlePrev}
                                className='chevon_meta_prev'
                                aria-label="Previous"
                                disabled={products.length === 0}
                            >
                                <svg width="70" height="70" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M15 6L9 12L15 18" stroke="#517769" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </button>
                            <div className='carouselItem' >
                                {products.length > 0 ? (
                                    <>
                                        <img src={products[activeIndex].image} alt={`carousel-item-${activeIndex}`} style={{ maxHeight: 120 }} />
                                        <br />
                                        <div className="price">{t('cms_name')}: {products[activeIndex].name}</div>
                                        <div className="price">{t('cms_value')}: {products[activeIndex].value}</div>
                                    </>
                                ) : (
                                    <div style={{ color: '#888' }}>{t('cms_no_products')}</div>
                                )}
                            </div>
                            <button
                                onClick={handleNext}
                                className='chevon_meta_next'
                                aria-label="Next"
                                disabled={products.length === 0}
                            >
                                <svg width="70" height="70" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9 6L15 12L9 18" stroke="#517769" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </button>
                        </div>
                        <div className="registro-form-cetes-inner">
                            <div className="btn-cetesJunior" style={{ margin: "20px auto" }}>
                                <button type="submit" onClick={handleClickResumen} >{t('meta_confirm')} </button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            {isLoading ? (
                <div className="loading">
                    <div className="spinner"></div>
                </div>
            ) : (
                <div>
                    {/* Resto del código */}
                </div>
            )}
        </div>
    );
}

export default Meta;